import { api } from "shared/api";
import { ApiResponse } from 'shared/model/types';

const confirmPhoneApi = api.injectEndpoints({
  endpoints: build => ({
    sendPhoneCode: build.query<ApiResponse<unknown>, void>({
      query: () => {
        return {
          url: '/user/phone/validate',
          method: 'GET',
        };
      }
    }),
    // Назначить тип для Language
    confirmPhoneCode: build.mutation<ApiResponse<unknown>, { code: string, language?: string }>({
      query: ({ code, language = 'EN' }) => {
        return {
          url: '/user/phone/confirm-validation',
          method: 'POST',
          params: {
            code,
            language,
          }
        };
      },
    }),
  })
});
export const { useConfirmPhoneCodeMutation, useSendPhoneCodeQuery } = confirmPhoneApi;